import { FDPRequestPayload, NavigationContext } from './types';
import PlatformTracker from './PlatformTracker';
import APIAdapter from '../APIAdapter';
import { getAppConfig } from '../utils/appConfigHelper';
import { IBaseAppConfig } from '../providers/types';

export default class WebTracker extends PlatformTracker {
  private adapterInstance: APIAdapter;
  private appConfig: IBaseAppConfig;

  constructor(tenantName: string) {
    super();
    this.appConfig = getAppConfig(tenantName);
    this.adapterInstance = new APIAdapter({
      enableHeliosDCSwitch: true,
      enableKevlarSessionService: true,
      shouldAvoidCache: true
    });
  }

  private pushEvents(data: FDPRequestPayload) {
    this.makeApiCall(data);
  }
  private makeApiCall(data: FDPRequestPayload, tries = 0) {
    const url =
      this.appConfig.fdpURL ??
      'https://rome.api.flipkart.com/api/4/data/collector/business';

    const requestOptions: RequestInit = {
      method: 'POST',
      body: JSON.stringify(data),
      keepalive: true
    };

    this.adapterInstance.fetch(url, requestOptions).catch(error => {
      if (
        typeof error === 'object' &&
        error?.status &&
        error.status >= 400 &&
        error.status < 500
      ) {
        return;
      }

      tries < 3 && this.makeApiCall(data, tries + 1);
    });
  }

  public getNavigationContext(): Promise<NavigationContext> {
    const nc = sessionStorage.getItem('nc');
    return Promise.resolve({
      ...this.getDefaultNavigationContext(),
      ...JSON.parse(nc ?? '{}')
    });
  }
  protected setNavigationContext(nc: NavigationContext) {
    sessionStorage.setItem('nc', JSON.stringify(nc));
  }
  private async getPayload(): Promise<FDPRequestPayload> {
    const e = this.events.slice();
    this.events = [];
    return {
      nc: await this.getNavigationContext(),
      e
    };
  }
  protected async sendData() {
    if (this.events.length > 0) {
      const data = await this.getPayload();
      this.pushEvents(data);
    }
  }
}
